import { formatReviewOrderStatusForDisplay, formatReviewTextForDisplay } from '@/shared/format-review-text-for-display';

type ReviewTableTextForDisplayInput = {
    author: string | null | undefined;
    orderStatus?: string | null | undefined;
    text: string | null | undefined;
    pros: string | null | undefined;
    cons: string | null | undefined;
    bables?: string[] | null | undefined;
};

type ReviewTableTextForDisplayOptions = {
    prosConsOnNewLines?: boolean;
    prosLabel?: string;
    consLabel?: string;
};

const normalizeText = (value: string | null | undefined): string => {
    if (typeof value !== 'string') {
        return '';
    }

    return value.trim();
};

const capitalizeFirstLetter = (value: string): string => {
    if (!value) {
        return value;
    }

    const firstCharacter = value.charAt(0);
    return `${firstCharacter.toLocaleUpperCase('ru-RU')}${value.slice(1)}`;
};

const joinPrefixWithReviewText = (prefix: string, reviewText: string): string => {
    if (!prefix) {
        return reviewText;
    }

    if (!reviewText) {
        return prefix;
    }

    return `${prefix}: ${reviewText}`;
};

export const formatReviewTableTextForDisplay = (
    { author, orderStatus, text, pros, cons, bables }: ReviewTableTextForDisplayInput,
    options: ReviewTableTextForDisplayOptions = {},
): string => {
    const prosLabel = options.prosLabel ?? '(+)';
    const consLabel = options.consLabel ?? '(-)';
    const reviewText = formatReviewTextForDisplay(
        {
            text,
            pros,
            cons,
            bables,
            orderStatus,
        },
        {
            prosConsOnNewLines: options.prosConsOnNewLines,
            prosLabel,
            consLabel,
            includeOrderStatus: false,
        },
    );
    const authorDisplay = capitalizeFirstLetter(normalizeText(author));
    const statusDisplay = capitalizeFirstLetter(formatReviewOrderStatusForDisplay(orderStatus) || '');
    const statusDisplayAfterAuthor = statusDisplay.toLocaleLowerCase('ru-RU');

    if (authorDisplay && statusDisplay) {
        return joinPrefixWithReviewText(`${authorDisplay}, ${statusDisplayAfterAuthor}`, reviewText);
    }

    if (authorDisplay) {
        return joinPrefixWithReviewText(authorDisplay, reviewText);
    }

    if (statusDisplay) {
        return joinPrefixWithReviewText(statusDisplay, reviewText);
    }

    return reviewText;
};
